const hoursOptions = [
    {
        code: '070000',
        label: '7h'
    },
    {
        code: '080000',
        label: '8h'
    },
    {
        code: '090000',
        label: '9h'
    },
    {
        code: '100000',
        label: '10h'
    },
    {
        code: '110000',
        label: '11h'
    },
    {
        code: '120000',
        label: '12h'
    },
    {
        code: '130000',
        label: '13h'
    },
    {
        code: '140000',
        label: '14h'
    },
    {
        code: '150000',
        label: '15h'
    },
    {
        code: '160000',
        label: '16h'
    },
    {
        code: '170000',
        label: '17h'
    },
    {
        code: '180000',
        label: '18h'
    },
    {
        code: '190000',
        label: '19h'
    },
    {
        code: '200000',
        label: '20h'
    },
    {
        code: '210000',
        label: '21h'
    },
    {
        code: '220000',
        label: '22h'
    },
    {
        code: '230000',
        label: '23h'
    },
    {
        code: '000000',
        label: '00h'
    }
]

export { hoursOptions }
